export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const utc_minutes_offset = new Date().getTimezoneOffset();
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        config.headers["utc_minutes_offset"] = utc_minutes_offset;
      }

      return config;
    },
    err => Promise.reject(err)
  );
}
